import get from "just-safe-get";
export async function importChunk<T> (loader: () => Promise<T>): Promise<T> {
	try {
		return await loader();
	} catch (err: unknown) {
		const message = String((err as Error)?.message || err);
        
		const code = get((err as Error), "code", null) as string | null;
		const failedImportMessages = [
			"Failed to fetch dynamically imported module",
			"Importing a module script failed",
			"Load failed",
			"Unable to preload CSS",
		];
        
		let wasFailedImport = code === "ERR_MODULE_NOT_FOUND";
		if (!wasFailedImport) { 
			wasFailedImport = failedImportMessages.some(errorText => message.includes(errorText));
		}
		if (wasFailedImport) {
			console.error("💣💣💣 Failed to import chunk, reloading...", { message, err });
			// window.location.reload();
		} else {
			console.error("Some other error occurred while importing chunk...", { message, err });
		}
		throw err;
	}
}

